<template>
  <div class="signin">
    <div class="left">
      <nuxt-link to="/" tag="div" class="logo" />
      <div class="bg" />
      <div v-if="isDesktop" class="advantages">
        <div class="item">
          <img src="/static_files/icons/advantages/premiere.svg" alt="premiere">
          <strong>Эксклюзивные премьеры</strong>
          <p>Оригинальные аниме подобранные специально для участников ANIMEAST.</p>
        </div>
        <div class="item">
          <img src="/static_files/icons/advantages/full-hd.svg" alt="full-hd">
          <strong>Отличное качество видео и звука</strong>
          <p>Качество Full HD 1080 и Ultra HD 4K, объемный звук Dolby 5.1 для максимального удовольствия от просмотра.</p>
        </div>
        <div class="item">
          <img src="/static_files/icons/advantages/devices.svg" alt="devices">
          <strong>Работа на всех устройствах</strong>
          <p>Cмотрите бесплатно где угодно — на Smart TV, в приложениях для iOS и Android.</p>
        </div>
      </div>
      <div class="footer">
        <a href="mailto:support@animeitochka.ru">
          <img src="/static_files/icons/email.svg">
          <span>support@animeitochka.ru</span>
        </a>
      </div>
    </div>
    <div class="right">
      <nuxt-link :to="`${ref.includes('/smotrim') ? '/' : ref}`" tag="i" class="icon-close" />
      <h1>
        Войдите на сайт и смотрите ANIMEAST бесплатно
      </h1>
      <div class="checkboxes">
        <!-- <label for="termofuse">
          <input type="checkbox" id="termofuse" v-model="checkbox['termofuse']">
          <span>
            Я принимаю условия
            <nuxt-link to="/privacy">Политики конфиденциальности</nuxt-link> и
            <nuxt-link to="/termsofuse">Пользовательского соглашения</nuxt-link>
          </span>
        </label>
        <label for="mailing">
          <input type="checkbox" id="mailing" v-model="checkbox['mailing']">
          <span>
            Я соглашаюсь получать рассылки и специальные предложения
          </span>
        </label> -->
        <p>
          Авторизируясь на сайте вы принимаете условия <nuxt-link to="/privacy">Политики конфиденциальности</nuxt-link> и
          <nuxt-link to="/termsofuse">Пользовательского соглашения</nuxt-link>
        </p>
        <label for="mailing">
          <input type="checkbox" id="mailing" v-model="checkbox['mailing']">
          <span>
            Я хочу получать рассылки и специальные предложения
          </span>
        </label>
      </div>
      <div class="socials">
        <strong>Используйте для входа</strong>
        <div class="items">
          <div @click="login('google')" class="item">
            <img src="/static_files/icons/signin/google.png" alt="google">
          </div>
          <div @click="login('mailru')" class="item">
            <img src="/static_files/icons/signin/mailru.png" alt="mailru">
          </div>
          <div @click="login('yandex')" class="item">
            <img src="/static_files/icons/signin/yandex.png" alt="yandex">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  head() {
    const fullPath = `https://animeitochka.ru/signin`
    return {
      title: `Вход на ANIMEAST`,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: fullPath
        }
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Вход на ANIMEAST`
        }
      ]
    }
  },
  layout: 'minimal',
  computed: mapState(['user', 'isDesktop']),
  asyncData({ query }) {
    return {
      kpid: query.id ? query.id : ''
    }
  },
  data() {
    return {
      checkbox: {
        termofuse: false,
        mailing: false
      },
      ref: '/'
    }
  },
  mounted() {
    if (this.$route.query.ref) {
      this.ref = this.$route.query.ref // this.$route.query.ref.includes('/smotrim?id') ? '/' : this.$route.query.ref
    }

    if (this.user) {
      location.href = this.ref
    }
//     else {
//       const rsyaMobileFS = document.createElement('script')
//       rsyaMobileFS.innerHTML = `
// window.yaContextCb.push(()=>{
//   Ya.Context.AdvManager.render({
//     type: 'fullscreen',
//     blockId: 'R-A-1740435-4'
//   })
// })`
//       document.body.appendChild(rsyaMobileFS)
//     }
  },
  methods: {
    login(social) {
      // if (!this.checkbox.termofuse) {
      //   this.$store.commit('setError', {
      //     status: 'warn',
      //     msg: 'Примите условия политики конфиденциальности и пользовательского соглашения'
      //   })
      //   setTimeout(() => this.$store.commit('clearError'), 3000)
      //   const elem = document.getElementById('termofuse')
      //   if (elem) {
      //     elem.style.border = `1px solid #e00a1e`
      //     elem.style.boxShadow = `0 0 20px 0px #e00a1e`
      //   }
      // } else if (!this.checkbox.mailing) {
      //   this.$store.commit('setError', { status: 'warn', msg: 'Подпишитесь на рассылку' })
      //   setTimeout(() => this.$store.commit('clearError'), 2000)
      //   const elem = document.getElementById('mailing')
      //   if (elem) {
      //     elem.style.border = `1px solid #e00a1e`
      //     elem.style.boxShadow = `0 0 20px 0px #e00a1e`
      //   }
      // } else {

      // }
      const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=900,height=600,left=10,top=10`
      window.open(`/api/auth/${social}`, `Sign in site - ${social}`, params)
    }
  }
}
</script>

<style src="~/assets/signin.styl" lang="stylus" />
